'use client';

import React, { useEffect, useState } from 'react';
import { Linkedin, Facebook } from 'lucide-react';

// ShareButtons bileşeni için prop tipi
interface ShareButtonsProps {
  title: string;
}

export default function ShareButtons({ title }: ShareButtonsProps) {
  // Paylaşım URL'sini tutacak state
  const [shareUrl, setShareUrl] = useState('');

  // Sayfa yüklendiğinde mevcut URL'yi al
  useEffect(() => {
    setShareUrl(window.location.href);
  }, []);

  // Paylaşım başlığını URL için kodla
  const shareTitle = encodeURIComponent(title);

  // Sosyal medya paylaşım düğmesi için ortak stil sınıfı
  const buttonClass = "p-1.5 sm:p-2 text-gray-400 hover:text-white transition-colors rounded-full hover:bg-white/10";

  return (
    <div className="flex items-center gap-2 sm:gap-4">
      <span className="text-sm sm:text-base text-gray-400">Share:</span>
      
      {/* Twitter (X) Paylaşım Düğmesi - Güncellenmiş X logosu */}
      <a
        href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClass}
        aria-label="Share on X"
      >
        {/* Özel X logosu SVG olarak */}
        <svg 
          viewBox="0 0 24 24" 
          aria-hidden="true" 
          className="h-4 w-4 sm:h-5 sm:w-5 fill-current"
        >
          <path d="M13.3174 10.7749L19.1457 4H17.7646L12.7039 9.88256L8.66193 4H4L10.1122 12.8955L4 20H5.38119L10.7254 13.7878L14.994 20H19.656L13.3171 10.7749H13.3174ZM11.4257 12.9738L10.8064 12.0881L5.87886 5.03974H7.91076L11.8287 10.5585L12.4479 11.4442L17.5989 18.8536H15.567L11.4257 12.9742V12.9738Z"/>
        </svg>
      </a>

      {/* LinkedIn Paylaşım Düğmesi */}
      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClass}
        aria-label="Share on LinkedIn"
      >
        <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" />
      </a>

      {/* Facebook Paylaşım Düğmesi */}
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className={buttonClass}
        aria-label="Share on Facebook"
      >
        <Facebook className="h-4 w-4 sm:h-5 sm:w-5" />
      </a>
    </div>
  );
}